import { Button, Card, CardMedia, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import profileImg from "../assets/images/profile-image.png";
import useStyles from "../components/MainTitle";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { motion } from "framer-motion";

function App() {
  const classes = useStyles();
  const [text] = useTypewriter({
    words: ["Front End Developer", "Freelancer Developer", "Web Designer"],
    loop: 0,
    typeSpeed: 40,
    deleteSpeed: 10,
  });
  return (
    <>
      <Stack direction="row">
        <Box className={classes.BigTitle}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 1 } }}
          >
            Main Page
          </motion.div>
          <Box className={classes.SmallTitle}>
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0, transition: { duration: 1 } }}
            >
              {" "}
              HOME
              <Box className={classes.afterClass} />
            </motion.div>
          </Box>
        </Box>
      </Stack>
      <Grid
        container
        spacing={2}
        sx={{
          flexDirection: { xs: "column-reverse", lg: "row" },
          transform: { lg: "translateY(100px)" },
          overflowX: "hidden",
        }}
      >
        <Grid item xs={12} lg={8}>
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography component={"span"} color="grey.main">
              <motion.div
                initial={{ opacity: 0, x: "-100vw" }}
                animate={{
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.7, delay: 0.8 },
                }}
              >
                Welcome to my awesome portofolio
              </motion.div>
            </Typography>
            <Typography
              variant="h1"
              color="light.main"
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                fontWeight: "600",
              }}
            >
              <motion.div
                initial={{ opacity: 0, x: "-100vw" }}
                animate={{
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.7, delay: 1 },
                }}
              >
                I am Mohamad Hamsho
              </motion.div>
            </Typography>
            <Typography
              variant="h2"
              color="light.main"
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                fontWeight: "600",
              }}
            >
              <motion.div
                initial={{ opacity: 0, x: "-100vw" }}
                animate={{
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.7, delay: 1.2 },
                }}
              >
                <span style={{ fontWeight: "bold" }}>
                  {text}
                  <span>
                    <Cursor cursorStyle="|" />{" "}
                  </span>
                </span>
              </motion.div>
            </Typography>
            <motion.div
              initial={{ opacity: 0, x: "-100vw" }}
              animate={{
                opacity: 1,
                x: 0,
                transition: { duration: 0.7, delay: 1.4 },
              }}
            >
              <Typography sx={{ margin: "10px 0" }} color="grey.main">
                My passion for front-end development shines through in every
                project I work on, as I constantly strive for innovation and
                excellence.
              </Typography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: "-100vw" }}
              animate={{
                opacity: 1,
                x: 0,
                transition: { duration: 0.7, delay: 1.6 },
              }}
            >
              <Typography
                sx={{
                  display: { xs: "none", md: "block" },
                  textAlign: "justify",
                }}
                color="grey.main"
              >
                With a keen eye for design and a deep understanding of user
                experience, I transform complex technical concepts into elegant,
                user-friendly solutions. I have a deep understanding of the
                latest technologies and trends in front-end development, and I
                always stay ahead of the curve to deliver cutting-edge
                solutions.
              </Typography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: "-100vw" }}
              animate={{
                opacity: 1,
                x: 0,
                transition: { duration: 0.7, delay: 1.7 },
              }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{ marginTop: { xs: "10px" } }}
              >
                Hire Me
              </Button>
            </motion.div>
          </Box>
        </Grid>
        <Grid item xs={12} lg={4}>
          <motion.div
            initial={{ opacity: 0, x: "100vw" }}
            animate={{
              opacity: 1,
              x: 0,
              transition: { duration: 1.5, delay: 0.7 },
            }}
          >
            <Card
              sx={{
                width: "100%",
                boxShadow: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "transparent",
              }}
            >
              <CardMedia
                className={classes.media}
                image={profileImg}
                // image="https://ibb.co/Khckk8M"
                title="Image"
              ></CardMedia>
            </Card>
          </motion.div>
        </Grid>
      </Grid>
    </>
  );
}

export default App;
